import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import BarraInferiorBotoes from '../../../../../components/BarraInferiorBotoes';
import BarraSubAbas from '../../../../../components/BarraSubAbas';
import BoxConteudo from '../../../../../components/BoxConteudo';
import ContainerConteudo from '../../../../../components/ContainerConteudo';
import CustomButton from '../../../../../components/CustomButton';
import CustomCol from '../../../../../components/CustomCol';
import CustomRow from '../../../../../components/CustomRow';
import Tabela from '../../../../../components/Tabela';
import WorkspaceBotoes from '../../../../../components/WorkspaceBotoes';
import {
  getUser,
  isActionAllowed,
} from '../../../../../modules/contexts/Auth/RequireAuth';
import { useComponentesPaf } from '../../../../../services/enum/useComponentesPaf';
import { useStatusOrgInter } from '../../../../../services/enum/useStatusOrgInter';
import { getAllOrgInters } from '../../../../../services/orgInters/orgIntersService';
import theme from '../../../../../theme';
import { ENTITY } from '../../../../../utils/entityNames';
import {
  formataNomeMeioSiglas,
  formatDate,
} from '../../../../../utils/functions';
import { SubAbas as subAbas } from '../../utils/subabasLogistica';
import {
  headersOrgInters,
  valoresExibidosOffCanvasOrgInters,
} from '../utils/auxiliarEntregaFornecedor';

const EntregaFornecedorIndex: React.FC = () => {
  //DADOS USUARIO
  const user = getUser();
  const userID = user.sub;
  const userComponenteAf = user.unidade - 1;
  const entity = ENTITY.ENTITY_Empenho;

  const navigate = useNavigate();
  //OPTIONS
  const statusOrgInter = useStatusOrgInter();
  const componenteAF = useComponentesPaf();

  //Dados do componente
  const [formFiltros, setFormFiltros] = useState({
    interfaceSisAf: 0,
    moduloSisAf: 0,
    tipoTask: 0,
    responsavel: 0,
    dataEntrada: '',
    dataFinalizacao: '',
    funcionalidade: '',
    descricao: '',
    complexidade: '',
    reaproveitamentoCodigo: '',
    statusDesenvolvimento: '',
    pontosFuncionalidade: 0,
    pontosDesenvolvidos: 0,
    observacoes: '',
    level: '',
  });
  const [data, setData] = useState<any[]>([]);

  // Buscar dados
  const fetchData = async () => {
    try {
      const registros = await getAllOrgInters();
      setData(registros);
    } catch (error) {
      console.error('Erro ao obter dados:', error);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  // TABELA E OFFCANVAS
  const tableData = data.map((item) => {
    // Definindo cores de fundo com base no status do documento
    let statusBackgroundColor = '';
    let colorText = 'black';

    const statusLabel = statusOrgInter[item.statusOrgInter].label;

    if (statusLabel === 'Em Elaboração') {
      statusBackgroundColor = theme.colors.amarelogov;
      colorText = 'white';
    } else if (statusLabel === 'Em Execução') {
      statusBackgroundColor = theme.colors.azulgov;
      colorText = 'white';
    } else if (statusLabel === 'Finalizado') {
      statusBackgroundColor = theme.colors.verdegov;
      colorText = 'white';
    } else if (statusLabel === 'Suspenso') {
      statusBackgroundColor = theme.colors.laranja;
      colorText = 'white';
    } else if (statusLabel === 'Cancelado') {
      statusBackgroundColor = theme.colors.vermelho;
      colorText = 'white';
    }

    const componenteSigla = componenteAF[item.componenteAf].label
      .slice(0, 1)
      .toUpperCase();

    let componenteBackgroundColor = '';
    const componenteTextColor = '';
    if (item.componenteAf === 1) {
      componenteBackgroundColor = theme.colors.azulgov;
    } else if (item.componenteAf === 2) {
      componenteBackgroundColor = theme.colors.amarelogov;
    } else if (item.componenteAf === 3) {
      componenteBackgroundColor = theme.colors.verdegov;
    }

    return {
      id: item.id,
      statusOrgInter: (
        <span
          style={{
            backgroundColor: statusBackgroundColor,
            color: colorText,
            borderRadius: '10px',
            padding: '12px',
            display: 'inline-block',
            minWidth: '100px',
            textAlign: 'center',
            fontWeight: 'bold',
          }}
        >
          {statusLabel}
        </span>
      ),
      componenteAf: (
        <div>
          <span
            style={{
              backgroundColor: componenteBackgroundColor,
              color: colorText,
              borderRadius: '10px',
              padding: '12px',
              display: 'inline-block',
              textAlign: 'center',
              fontWeight: 'bold',
            }}
          >
            {componenteSigla}
          </span>
          <span style={{ marginLeft: '8px' }}>
            {componenteAF[item.componenteAf].label}
          </span>
        </div>
      ),
      //numeroSeiArp: item.numeroSeiArp,
      orgSigla: item.orgSigla,
      nupEspecifico: item.nupEspecifico,
      nProdutos: (
        <span
          style={{
            padding: '5px',
            display: 'inline-block',
            minWidth: '90px',
            textAlign: 'right',
          }}
        >
          0
        </span>
      ),
      valorTotal: (
        <span
          style={{
            display: 'inline-block',
            minWidth: '100px',
            textAlign: 'right',
          }}
        >
          0
        </span>
      ),
    };
  });

  const offCanvasData = data.map((item) => {
    // Definindo cores de fundo com base no status do documento
    let statusBackgroundColor = '';
    let colorText = 'black';

    const statusLabel = statusOrgInter[item.statusOrgInter].label;

    if (statusLabel === 'Em Elaboração') {
      statusBackgroundColor = theme.colors.amarelogov;
      colorText = 'white';
    } else if (statusLabel === 'Em Execução') {
      statusBackgroundColor = theme.colors.azulgov;
      colorText = 'white';
    } else if (statusLabel === 'Finalizado') {
      statusBackgroundColor = theme.colors.verdegov;
      colorText = 'white';
    } else if (statusLabel === 'Suspenso') {
      statusBackgroundColor = theme.colors.laranja;
      colorText = 'white';
    } else if (statusLabel === 'Cancelado') {
      statusBackgroundColor = theme.colors.vermelho;
      colorText = 'white';
    }

    const componenteSigla = componenteAF[item.componenteAf].label
      .slice(0, 1)
      .toUpperCase();

    let componenteBackgroundColor = '';
    const componenteTextColor = '';
    if (item.componenteAf === 1) {
      componenteBackgroundColor = theme.colors.azulgov;
    } else if (item.componenteAf === 2) {
      componenteBackgroundColor = theme.colors.amarelogov;
    } else if (item.componenteAf === 3) {
      componenteBackgroundColor = theme.colors.verdegov;
    }

    return {
      id: item.id,
      dataRegistro:
        formatDate(item.dataRegistro) +
        ' - ' +
        formataNomeMeioSiglas(item.usuarioRegistro.nomeCompleto),
      dataUltimaAtualizacao:
        formatDate(item.dataUltimaAtualizacao) +
        ' - ' +
        formataNomeMeioSiglas(item.usuarioAtualizacao.nomeCompleto),

      dataUltimaVisualizacao:
        formatDate(item.dataUltimaVisualizacao) +
        ' - ' +
        formataNomeMeioSiglas(item.usuarioUltimaVisualizacao.nomeCompleto),
      nEdicoes: item.nEdicoes,
      nVisualizacoes: item.nVisualizacoes,
      separadorLog: '',
      statusOrgInter: (
        <span
          style={{
            backgroundColor: statusBackgroundColor,
            color: colorText,
            borderRadius: '10px',
            padding: '12px',
            display: 'inline-block',
            minWidth: '100px',
            textAlign: 'center',
            fontWeight: 'bold',
          }}
        >
          {statusLabel}
        </span>
      ),
      componenteAf: (
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-start',
          }}
        >
          <span
            style={{
              backgroundColor: componenteBackgroundColor,
              color: colorText,
              borderRadius: '10px',
              padding: '12px',
              display: 'inline-block',
              textAlign: 'center',
              fontWeight: 'bold',
            }}
          >
            {componenteSigla}
          </span>
          <span style={{ marginLeft: '8px' }}>
            {componenteAF[item.componenteAf].label}
          </span>
        </div>
      ),
      //numeroSeiArp: item.numeroSeiArp,
      orgSigla: item.orgSigla,
      nupGeral: item.nupGeral,
      nupEspecifico: item.nupEspecifico,
      nProdutos: <span>0</span>,
      valorTotal: <span>0</span>,
    };
  });

  const handleClickInserir = () => {
    navigate('ficha/dadosgerais', { state: { userComponenteAf } });
  };

  const handleChange = (e: any) => {
    const { name, value } = e.target;

    if (name === 'level' || name === 'statusDesenvolvimento') {
      // Permitir somente números, '<', '>', ou uma combinação destes com números
      if (
        /^[0-9]*$/.test(value) ||
        value === '<' ||
        value === '>' ||
        /^[<>][0-9]+$/.test(value)
      ) {
        setFormFiltros((prev) => ({ ...prev, [name]: value }));
      }
    } else if (name === 'interfaceSisAf' || name === 'moduloSisAf') {
      const newValue = parseInt(value, 10);
      setFormFiltros({
        ...formFiltros,
        [name]: newValue,
      });
    } else {
      setFormFiltros((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleClearFiltros = () => {
    setFormFiltros({
      ...formFiltros,
      interfaceSisAf: 0,
      moduloSisAf: 0,
      tipoTask: 0,
      responsavel: 0,
      dataEntrada: '',
      dataFinalizacao: '',
      funcionalidade: '',
      descricao: '',
      complexidade: '',
      reaproveitamentoCodigo: '',
      statusDesenvolvimento: '',
      pontosFuncionalidade: 0,
      pontosDesenvolvidos: 0,
      observacoes: '',
      level: '',
    });
  };

  return (
    <>
      <BarraSubAbas subAbas={subAbas} />

      <ContainerConteudo>
        <BoxConteudo boxTitulo="Filtros" fechado>
          <CustomRow style={{ marginTop: '-15px' }}>
            {/* <CustomCol width="150px">
              <Input
                name="level"
                label="Level"
                value={formFiltros.level}
                id="level"
                onChange={handleChange}
                style={{ textAlign: 'right' }}
              />
            </CustomCol> */}
          </CustomRow>
          <CustomRow style={{ marginTop: '-15px', textAlign: 'right' }}>
            <CustomCol className="mt-3 justify-content-end align-content-end">
              <CustomButton
                label="Limpar filtros"
                bgColor="#808080" // Cor cinza
                textColor="#ffffff" // Texto branco
                onClick={handleClearFiltros}
              />
            </CustomCol>
          </CustomRow>
        </BoxConteudo>

        <Tabela
          headers={headersOrgInters}
          dataTable={tableData}
          dataOffCanvas={offCanvasData}
          displayValues={valoresExibidosOffCanvasOrgInters}
          tituloCanvas="Organismo Internacional"
        />
      </ContainerConteudo>

      <BarraInferiorBotoes>
        <WorkspaceBotoes download inserir onClickInserir={handleClickInserir} />
      </BarraInferiorBotoes>
    </>
  );
};

export default EntregaFornecedorIndex;
